import { dictionaryCRUD } from "../../../actions/dictionary"
import { selector } from "../../../api"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useState } from "react"
import { toast } from "react-toastify"

const dictionarySchema = Yup.object().shape({
  dictionary_name_en: Yup.string().required('English name is required'),
  dictionary_name_sw: Yup.string().required('Swahili name is required'),
})

const initialValues = {
  dictionary_name_en: '',
  dictionary_name_sw: '',
}

export const AddDictionary = (props) => {

  const {setIndex, index} = props

  const user = selector.User()
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues,
    validationSchema: dictionarySchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { dictionary_name_en, dictionary_name_sw } = values
      const recorded_by = user.id
      const data = { dictionary_name_en, dictionary_name_sw, recorded_by }
      setLoading(true)
      setTimeout(() => {
        dictionaryCRUD.addDictionary(data).then(() => {
          toast.success('New dictionary has been created.', {autoClose: 7000})
          setIndex(index+1)
          resetForm()
          setLoading(false)
          setSubmitting(false)
        }).catch((error) => {
          setLoading(false)
          setSubmitting(false)
          toast.error(error.message, {autoClose: 7000})
        })
      }, 2000)

    }
  })

  return (
    <>
      <div class="modal fade addModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">New Dictionary</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr/>
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label className="form-label">English Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" {...formik.getFieldProps('dictionary_name_en')} placeholder="English Name" />
                      {formik.touched.dictionary_name_en && formik.errors.dictionary_name_en && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.dictionary_name_en}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label className="form-label">Swahili Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" {...formik.getFieldProps('dictionary_name_sw')} placeholder="Swahili Name" />
                      {formik.touched.dictionary_name_sw && formik.errors.dictionary_name_sw && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.dictionary_name_sw}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <hr/>
              <div className="modal-footer">
                <a href="javascript:void(0);" className="btn btn-soft-danger fw-medium" data-bs-dismiss="modal"><i className="ri-close-line me-1 align-middle"></i> Close</a>
                <button type='submit' className="btn btn-soft-success" disabled={formik.isSubmitting || !formik.isValid}>
                  {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i>save </span>}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )

}